
import React from "react";
import { TrainingErrorDisplay } from "../TrainingErrorDisplay";

interface TrainingErrorViewProps {
  onReload: () => void;
}

export function TrainingErrorView({ onReload }: TrainingErrorViewProps) {
  return <TrainingErrorDisplay onReload={onReload} />;
}
